import { render, staticRenderFns } from "./SendCertificate.vue?vue&type=template&id=2c29e08d&scoped=true"
import script from "./SendCertificate.vue?vue&type=script&lang=js"
export * from "./SendCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c29e08d",
  null
  
)

export default component.exports